import { render, staticRenderFns } from "./BuildYourCompany.vue?vue&type=template&id=dec9463a"
import script from "./BuildYourCompany.vue?vue&type=script&lang=js"
export * from "./BuildYourCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports